import React, { Component } from "react";
import PropTypes from "prop-types";
import DispatchTableHead from "./TableHead";
import { Container, Draggable } from "react-smooth-dnd";

class JobsTable extends Component {
  state = {
    job: null,
    open: false,
  };

  sortedJobsByIndex = () => {
    const { jobs } = this.props;
    return jobs.sort((a, b) => a.index - b.index);
  };

  jobRef = (job) => {
    const { employees, jobs, captainNo, trucks, toolboxes } = this.props;
    let link = "https://www.moncasa.ca/srj-moncasa/login.php?";

    const {
      prd_id,
      resource,
      reference,
      code_casa,
      client,
      address, // add1
      city, // add2
      postal_code, // add3
      country, // add4
      distance, // km
      description, // travaux
    } = job;

    if (job.representant) {
      link += "Representant=" + job.representant + "&";
    }

    // taken form old code
    let sequences = [];
    const travaux = [];
    for (let i = 0; i < jobs.length; i++) {
      const j = jobs[i];
      if (j.prd_id === job.prd_id) {
        sequences.push(j.sequence + "-" + j.step);
        travaux.push(j.description);
      }
    }

    // taken from old code
    const vcs = toolboxes.concat(trucks);
    if (prd_id) {
      link += "Prd_id=" + prd_id + "&";
    }
    if (resource) {
      link += "Ressource=" + resource + "&";
    }
    if (reference) {
      link += "Reference=" + reference + "&";
    }
    if (code_casa) {
      link += "Client_id=" + code_casa + "&";
    }
    if (client) {
      link += "Client=" + client + "&";
    }
    if (address) {
      link += "Add1=" + address + "&";
    }
    if (city) {
      link += "Add2=" + city + "&";
    }
    if (postal_code) {
      link += "Add3=" + postal_code + "&";
    }
    if (country) {
      link += "Add4=" + country + "&";
    }
    if (distance) {
      link += "tg=" + distance + "&";
    }
    if (captainNo) {
      link += "Chef=" + captainNo + "&";
    }
    if (employees && employees.length > 0) {
      link += "Employes=";
      for (let i = 0; i < employees.length; i++) {
        let emp = employees[i];
        link += emp.employee_number;
        link += ";";
      }

      link += "&";
    }
    if (travaux && travaux.length > 0) {
      link += "Travaux=" + travaux[0];
      for (let i = 1; i < travaux.length; i++) {
        link += "~";
        link += travaux[i];
      }
      link += "~";
      link += "&";
    }
    if (vcs && vcs.length > 0) {
      link += "Vehicules=";

      // for (vc of vcs) {
      for (let i = 0; i < vcs.length; i++) {
        let vc = vcs[i];
        link += vc.name;
        link += ";";
      }

      link += "&";
    }
    if (sequences.length > 0) {
      link += "Sequences=";
      link += sequences[0];
      for (let i = 1; i < sequences.length; i++) {
        link += "~";
        link += sequences[i];
      }
    }
    link += "~";

    return encodeURI(link.replace("#", "%23"));
  };

  render() {
    const {
      jobs,
      handleToggleItemModal,
      handleDeleteClick,
      copyType,
      handleCopy,
      handlePaste,
      teamID,
      handleReorderJobs,
      userType,
      isTeamCaptain,
      captainNo,
      handleOpenModal,
    } = this.props;

    const jobsLength = jobs ? jobs.length : 0;
    const MAX_JOBS = 8;
    const emptyCells = new Array(Math.max(MAX_JOBS - jobsLength, 0)).fill(0);

    return (
      <div>
        <table className="jobs">
          <DispatchTableHead
            numberOfItems={jobsLength}
            title="Liste des travaux"
            span={3}
            onAddClick={() => handleToggleItemModal(5)}
            active={copyType === "jobs"}
            userType={userType}
            isTeamCaptain={isTeamCaptain}
            captainNo={captainNo}
            onOptionClick={() =>
              copyType === "jobs" ? handlePaste() : handleCopy(teamID)
            }
          />
          <tbody>
            {userType === "admin" ? (
              <Container
                orientation="vertical"
                groupName={`TEAM-${teamID}`}
                onDrop={(dropResult) => {
                  handleReorderJobs(
                    teamID,
                    dropResult.removedIndex, // start
                    dropResult.addedIndex // end
                  );
                }}
              >
                {this.sortedJobsByIndex().map((job, index) => {
                  if (job) {
                    return (
                      <Draggable key={job.id}>
                        <tr>
                          <td
                            className={
                              job.contacted ? "contacted index" : "index"
                            }
                          >
                            {index + 1}
                          </td>
                          <td
                            onClick={() => handleOpenModal(job)}
                            className={job.note ? "has_note" : ""}
                          >
                            <div className="title">
                              <span className="prd_id">
                                {job.prd_id}-{job.sequence}
                              </span>
                              -<span className="step">{job.step} </span>
                              <span className="client">{job.client}</span>
                            </div>
                            <div className="subTitle">
                              <span className="no_client" />
                              <span className="description">
                                {job.description}
                              </span>
                            </div>
                          </td>
                          <td
                            className="delete-icon"
                            onClick={() => handleDeleteClick(job.id, job.index)}
                          >
                            <i className="fa fa-times" aria-hidden="true" />
                          </td>
                        </tr>
                      </Draggable>
                    );
                  }
                  return <React.Fragment></React.Fragment>;
                })}
                {emptyCells.map((cell, index) => (
                  <tr className="empty" key={`empty-${index}`}>
                    <td className="index">{jobsLength + index + 1}</td>
                    <td />
                    <td />
                  </tr>
                ))}
              </Container>
            ) : (
              <React.Fragment>
                {this.sortedJobsByIndex().map((job, index) => {
                  if (job) {
                    return (
                      <tr key={job.id}>
                        <td
                          className={
                            job.contacted ? "contacted index" : "index"
                          }
                        >
                          {isTeamCaptain ? (
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={this.jobRef(job)}
                            >
                              {index + 1}
                            </a>
                          ) : (
                            index + 1
                          )}
                        </td>
                        <td
                          onClick={() => handleOpenModal(job)}
                          className={job.note ? "has_note" : ""}
                        >
                          <div className="title">
                            <span className="prd_id">
                              {job.prd_id}-{job.sequence}
                            </span>
                            -<span className="step">{job.step} </span>
                            <span className="client">{job.client}</span>
                          </div>
                          <div className="subTitle">
                            <span className="no_client" />
                            <span className="description">
                              {job.description}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                  return <React.Fragment></React.Fragment>;
                })}
                {emptyCells.map((cell, index) => (
                  <tr className="empty" key={`empty-${index}`}>
                    <td className="index">{jobsLength + index + 1}</td>
                    <td />
                    <td />
                  </tr>
                ))}
              </React.Fragment>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

JobsTable.propTypes = {
  jobs: PropTypes.array,
  handleToggleItemModal: PropTypes.func,
  handleDeleteClick: PropTypes.func,
  handleReorderJobs: PropTypes.func,
};

export default JobsTable;
